import React, { useEffect, useState } from 'react';
import Form from '../Form';
import SVG from '../SVG';
import Tooltip from '../Tooltip';
import * as S from './styles';
import { DropdownItem } from '../Input/InputDropdown';

export interface TableHeaderCellFilterProps {
  filter?: {
    value: any;
    onChange: (e) => void;
    onSelected?: (item: DropdownItem) => void;
    items?: DropdownItem[];
    handleItems?: (e: any) => void;
    label?: string;
    mask?: (value: any) => any;
    unmask?: (value: any) => any;
    loading?: boolean;
  };
  sort?: {
    value: any;
    onChange: (e) => void;
  };
  interval?: [
    {
      type?: 'date';
      value: any;
      onChange: (e) => void;
      onClear?: (e) => void;
      label?: string;
    },
    {
      type?: 'date';
      value: any;
      onChange: (e) => void;
      label?: string;
    },
  ];
  tooltip?: {
    translateX?: number;
  };
  onClear?: (e) => void;
}

function TableHeaderCellFilter({
  sort,
  filter,
  interval,
  tooltip,
  onClear,
}: TableHeaderCellFilterProps) {
  const isNotEmpty = (value) => !['', null, undefined].includes(value);
  const hasFilterValue =
    isNotEmpty(filter?.value) ||
    isNotEmpty(interval?.[0].value) ||
    isNotEmpty(interval?.[1].value);

  const [isVisible, setIsVisible] = useState(false);

  const onDebouncedChange = (e) => {
    filter?.handleItems && filter.handleItems(e);
  };
  const onSelected = (item: DropdownItem) => {
    if (filter?.onSelected) {
      filter.onSelected(item);
    } else {
      filter?.onChange &&
        filter.onChange({
          target: {
            value: `${item.name}`,
          },
        });
    }
  };

  return sort || filter ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyItems: 'center',
      }}
    >
      {filter || interval ? (
        <Tooltip
          translateX={tooltip?.translateX}
          alignment="bottom"
          visibility={isVisible}
          onVisibility={setIsVisible}
          content={(() => {
            return (
              <div
                style={{
                  color: 'black',
                  width: '20vw',
                  fontWeight: 'normal',
                }}
              >
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  {interval ? (
                    <>
                      <div style={{ marginTop: '1rem' }}>
                        <Form.Input.DatePicker
                          label={interval[0].label}
                          value={interval[0].value}
                          onChange={interval[0].onChange}
                        />
                      </div>
                      <div style={{ marginTop: '2rem' }}>
                        <Form.Input.DatePicker
                          label={interval[1].label}
                          value={interval[1].value}
                          onChange={interval[1].onChange}
                        />
                      </div>
                      {onClear ? (
                        <Form.Button
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '45px',
                            width: '150px',
                            margin: '2rem 0 auto auto',
                            color: 'white',
                            fontWeight: 400,
                            fontSize: '20px',
                            background: '#11465d',
                            borderRadius: '10px',
                          }}
                          onClick={(e) => {
                            onClear(e);
                            if (!interval[0].value && !interval[1].value)
                              setIsVisible(false);
                          }}
                        >
                          Limpar
                        </Form.Button>
                      ) : null}
                    </>
                  ) : null}
                  {filter ? (
                    !filter.items ? (
                      <Form.Input
                        value={filter.value}
                        onChange={filter.onChange}
                      />
                    ) : (
                      <div style={{ marginTop: '1rem' }}>
                        <Form.Input.Dropdown
                          mask={filter.mask}
                          unmask={filter.unmask}
                          label={filter.label}
                          value={filter.value}
                          onChange={filter.onChange}
                          errorMessage={false}
                          fontSize={18}
                          hasClearItem
                          onDebouncedChange={onDebouncedChange}
                          items={filter.items}
                          onFocus={(e) => {
                            filter.onChange({
                              ...e,
                              target: {
                                ...e.target,
                                value: '',
                              },
                            });
                          }}
                          onSelected={onSelected}
                          loading={filter?.loading ?? false}
                        />

                        {onClear ? (
                          <Form.Button
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '45px',
                              width: '150px',
                              margin: '2rem 0 auto auto',
                              color: 'white',
                              fontWeight: 400,
                              fontSize: '20px',
                              background: '#11465d',
                              borderRadius: '10px',
                            }}
                            onClick={(e) => {
                              onClear(e);
                              if (!filter.value) setIsVisible(false);
                            }}
                          >
                            Limpar
                          </Form.Button>
                        ) : null}
                      </div>
                    )
                  ) : null}
                </Form>
              </div>
            );
          })()}
        >
          <S.FilterContainer active={isVisible}>
            {
              <SVG.Icon.Filter
                color={
                  hasFilterValue || isVisible ? '#11465d' : 'rgba(0, 0, 0, 0.2)'
                }
              />
            }
          </S.FilterContainer>
        </Tooltip>
      ) : (
        <></>
      )}
      {sort ? (
        <S.FilterContainer
          onClick={() => {
            switch (sort?.value) {
              case undefined:
                sort?.onChange('ASC');
                break;
              case 'ASC':
                sort?.onChange('DESC');
                break;
              case 'DESC':
                sort?.onChange(undefined);
                break;
              default:
                break;
            }
          }}
        >
          {sort?.value === 'ASC' ? (
            <SVG.Icon.Arrow.Up color="#11465d" />
          ) : sort?.value === 'DESC' ? (
            <SVG.Icon.Arrow.Down color="#11465d" />
          ) : (
            <SVG.Icon.Arrow.Up color="rgba(0, 0, 0, 0.2)" />
          )}
        </S.FilterContainer>
      ) : null}
    </div>
  ) : null;
}
export default TableHeaderCellFilter;
